/* eslint-disable */
const FXQ = {
  // 签章颜色定义
  colors: ['red', 'blue', '#000'],

  // 签章字体定义
  fonts: ['SimSun', 'YouYuan', 'KaiTi', 'FangSong'],

  baseConf: {
    color: null,
    font: null,
  },

  commonMethod(cType, fType) {
    let color = null
    color = this.colors[cType]
    if (color === undefined || color == 'undefined') {
      color = this.colors[0]
    }

    let font = this.fonts[fType]
    if (font === undefined || font == 'undefined') {
      font = this.fonts[0]
    }

    this.baseConf.color = color
    this.baseConf.font = font
  },
  // 椭圆签章
  // sealWidth
  // sealHeight
  companyEllipse({ companyName = '', code = '', text = '', fType, cType }) {
    // 椭圆长轴半径
    let radiusX = (4 / 5.8) * 140
    // 短轴半径
    let radiusY = (3 / 5.8) * 120
    this.commonMethod(cType, fType)
    let { color } = FXQ.baseConf
    let { font } = FXQ.baseConf

    // var canvas = document.getElementById('canvas');
    let canvas = document.createElement('canvas')
    // sizeWidth = Math.ceil((sizeWidth/5.8)*220)
    // sizeHeight = Math.ceil((sizeHeight/5.8)*220)

    // canvas.width = 300
    // canvas.height = 300

    canvas.width = 2 * radiusX + 5
    canvas.height = 2 * radiusY + 5

    let context = canvas.getContext('2d')

    writeFont(true, companyName)
    // writeFont(false, code)
    writeTitle()
    writeCode()
    drawEllipse()

    function writeFont(isTop, words) {
      let totalArcAng = 180
      font = `12px SimSun`

      // 字体长度
      if (!isTop) {
        totalArcAng = 60
        font = `10px ${font}`
      }
      let fontTextLen = words.length

      let radiusWidth = radiusX + context.lineWidth
      let radiusHeight = radiusY + context.lineWidth

      // 从边线向中心的移动因子
      let minRat = 0.9
      // 起始角度
      let startAngle =
        isTop == true ? -90 - totalArcAng / 2 : 90 - totalArcAng / 2
      let step = 1
      let alCount = Math.ceil(totalArcAng / step) + 1
      let angleArr = new Array(alCount)
      let arcLenArr = new Array(alCount)
      let num = 0
      let accArcLen = 0
      angleArr[num] = startAngle
      arcLenArr[num] = accArcLen
      num++
      let angR = (startAngle * Math.PI) / 180
      let lastX = radiusX * Math.cos(angR) + radiusWidth
      let lastY = radiusY * Math.sin(angR) + radiusHeight

      for (var i = startAngle + step; num < alCount; i += step) {
        angR = (i * Math.PI) / 180
        var x = radiusX * Math.cos(angR) + radiusWidth
        var y = radiusY * Math.sin(angR) + radiusHeight
        accArcLen += Math.sqrt(
          (lastX - x) * (lastX - x) + (lastY - y) * (lastY - y)
        )
        angleArr[num] = i
        arcLenArr[num] = accArcLen
        lastX = x
        lastY = y
        num++
      }

      let arcPer = accArcLen / fontTextLen
      for (var i = 0; i < fontTextLen; i++) {
        let arcL = i * arcPer + arcPer / 2
        let ang = 0
        for (let p = 0; p < arcLenArr.length - 1; p++) {
          if (arcLenArr[p] <= arcL && arcL <= arcLenArr[p + 1]) {
            ang =
              arcL >= (arcLenArr[p] + arcLenArr[p + 1]) / 2
                ? angleArr[p + 1]
                : angleArr[p]
            break
          }
        }
        angR = (ang * Math.PI) / 180
        let x = radiusX * Math.cos(angR) + radiusX
        let y = radiusY * Math.sin(angR) + radiusY
        y -= 2
        if (fontTextLen <= 14) {
          if (i > 0) {
            x += 5
          }
          if (i === fontTextLen - 1) {
            y += 5
          }
        }

        let qxang = Math.atan2(
          radiusY * Math.cos(angR),
          -radiusX * Math.sin(angR)
        )
        let fxang = qxang + Math.PI / 2

        let subIndex = isTop == true ? i : fontTextLen - 1 - i
        let c = words[subIndex]
        let w = 25
        let h = 31

        if (!isTop) {
          w = 2
          h = 10
        }

        x += h * minRat * Math.cos(fxang)
        y += h * minRat * Math.sin(fxang)
        if (isTop) {
          x += (-w / 2) * Math.cos(qxang)
          y += (-w / 2) * Math.sin(qxang)
        } else {
          // x += (w / 2) * Math.cos(qxang)
          // y += (w / 2) * Math.sin(qxang)
        }

        context.save()
        context.translate(x, y)
        if (isTop == true) {
          context.rotate(
            (((fxang * 180) / Math.PI - 90) * Math.PI) / 180 - 0.07
          )
        } else {
          // context.rotate((((fxang * 180) / Math.PI + 180 - 90) * Math.PI) / 180)
        }
        context.translate(-x, -y)
        context.fillStyle = color
        context.font = font
        context.fillText(c, x, y)
        context.restore()
      }
    }

    function writeTitle() {
      context.fillStyle = color
      context.font = '12x FangSong'
      context.textAlign = 'center'
      context.fillText(text, radiusX, radiusY + 20)
      context.restore()
    }

    function writeCode() {
      context.fillStyle = color
      context.font = '10px Arial'
      context.textAlign = 'center'
      context.fillText(code, radiusX, radiusY + 40)
      context.restore()
    }

    function drawEllipse() {
      context.ellipse(
        radiusX + context.lineWidth + 1,
        radiusY + context.lineWidth + 1,
        radiusX,
        radiusY,
        0,
        0,
        Math.PI * 2
      )
      // 背景透明
      context.fillStyle = 'rgba(255, 255, 255, 0)'
      context.strokeStyle = color
      context.lineWidth = 3
      context.fill()
      context.stroke()
    }

    // 返回图片base64
    return canvas.toDataURL('image/png', 1.0)
  },
  /**
   * 字体换行
   * */
  wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    if (
      typeof text != 'string' ||
      typeof x != 'number' ||
      typeof y != 'number'
    ) {
      return
    }

    let context = ctx
    let { canvas } = context

    if (typeof maxWidth == 'undefined') {
      maxWidth = (canvas && canvas.width) || 112
    }
    if (typeof lineHeight == 'undefined') {
      lineHeight =
        (canvas && parseInt(window.getComputedStyle(canvas).lineHeight)) ||
        parseInt(window.getComputedStyle(document.body).lineHeight)
    }

    // 字符分隔为数组
    let arrText = text.split('')
    let line = ''

    for (let n = 0; n < arrText.length; n++) {
      let testLine = line + arrText[n]
      let metrics = context.measureText(testLine)
      let testWidth = metrics.width
      if (testWidth > maxWidth && n > 0) {
        context.fillText(arrText[0], x, y)
        context.fillText(arrText[1], x + 50, y)
        line = arrText[n]
        y += lineHeight
      } else {
        line = testLine
      }
    }
    context.fillText(arrText[2], x, y + 10)
    context.fillText(arrText[3], x + 50, y + 10)
  },
}
export default FXQ
